module.exports = __webpack_public_path__ + "static/media/deleteIcon (1).2583bdbc.svg";